import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { SkeletonBlock } from '../../SkeletonBlock/SkeletonBlock';

interface SkeletonListRowProps {
  rightBlock?: ReactNode;
  rowClassName?: string;
  leftBlock?: ReactNode;
}

const DEFAULT_LEFT_BLOCK = (
  <SkeletonBlock className="h-[12px] min-w-[133px] w-full rounded-[24px]" variant="sunked" />
);

export function SkeletonListRow(props: SkeletonListRowProps) {
  const { rightBlock, rowClassName = 'gap-[8px]', leftBlock } = props;

  return (
    <div className={twMerge('flex items-center justify-between', rowClassName)}>
      <div className="flex items-center gap-[8px] flex-1 min-w-0">
        <SkeletonBlock className="size-[32px] shrink-0 rounded-[24px]" variant="sunked" />
        {leftBlock ?? DEFAULT_LEFT_BLOCK}
      </div>
      {rightBlock}
    </div>
  );
}
